import { ArrowLeft } from "lucide-react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background py-20 px-6">
      <div className="container mx-auto max-w-3xl">
        <a href="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Voltar ao site
        </a>

        <h1 className="text-3xl font-bold text-foreground mb-8">Política de Privacidade</h1>

        <div className="prose prose-invert prose-sm max-w-none space-y-6 text-muted-foreground">
          <p>Última atualização: abril de 2026</p>

          <h2 className="text-xl font-semibold text-foreground">1. Informações Gerais</h2>
          <p>
            A Agência Ad4You ("nós") está comprometida em proteger a privacidade dos visitantes deste site.
            Esta política descreve como coletamos, usamos e protegemos suas informações pessoais.
          </p>

          <h2 className="text-xl font-semibold text-foreground">2. Dados Coletados</h2>
          <p>Podemos coletar os seguintes dados:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Nome e informações de contato (e-mail, telefone) fornecidos voluntariamente</li>
            <li>Dados de navegação (cookies, endereço IP, páginas visitadas)</li>
            <li>Informações de pagamento processadas por terceiros (Pagar.me)</li>
          </ul>

          <h2 className="text-xl font-semibold text-foreground">3. Uso dos Dados</h2>
          <p>Utilizamos suas informações para:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Processar pedidos e pagamentos</li>
            <li>Entrar em contato sobre projetos contratados</li>
            <li>Melhorar nossos serviços e experiência do site</li>
            <li>Enviar comunicações relevantes (mediante consentimento)</li>
          </ul>

          <h2 className="text-xl font-semibold text-foreground">4. Cookies e Rastreamento</h2>
          <p>
            Este site utiliza Google Tag Manager, Google Ads e Meta Pixel para fins de análise e remarketing.
            Você pode gerenciar suas preferências de cookies nas configurações do seu navegador.
          </p>

          <h2 className="text-xl font-semibold text-foreground">5. Compartilhamento de Dados</h2>
          <p>
            Não vendemos ou compartilhamos dados pessoais com terceiros, exceto quando necessário para
            processamento de pagamentos ou conforme exigido por lei.
          </p>

          <h2 className="text-xl font-semibold text-foreground">6. Segurança</h2>
          <p>
            Adotamos medidas técnicas e organizacionais para proteger seus dados pessoais contra
            acesso não autorizado, perda ou destruição.
          </p>

          <h2 className="text-xl font-semibold text-foreground">7. Seus Direitos</h2>
          <p>
            Conforme a LGPD (Lei Geral de Proteção de Dados), você tem o direito de acessar,
            corrigir, excluir ou solicitar a portabilidade de seus dados pessoais.
          </p>

          <h2 className="text-xl font-semibold text-foreground">8. Contato</h2>
          <p>
            Para dúvidas sobre esta política, entre em contato:<br />
            E-mail: agenciaad4you@gmail.com<br />
            WhatsApp: (19) 98827-8133
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;